module.exports = __webpack_public_path__ + "Lato-BlackItalic.6c522f09efc8b8327166";


//////////////////
// WEBPACK FOOTER
// E:/Projects/HaMafteach/HaMafteach Comprehensive/online-database/web-client/src/assets/fonts/Lato/Lato-BlackItalic.ttf
// module id = ../../../../../src/assets/fonts/Lato/Lato-BlackItalic.ttf
// module chunks = styles